import React from "react";
import Navbar from "../../../Components/Navbar/Navbar";
import HeaderSection from "../../../Components/HeaderSection/HeaderSection";
import ImageComp from "../../../Components/ImageComp/ImageComp";
import Text from "../../../Components/Text/Text";
import Footer from "../../../Components/Footer/Footer";
import { Helmet } from "react-helmet";

export default function UzairHeadOfProducts_Iot() {
  return (
    <div className="LeaderShip">
      <Helmet>
        <title>Head of Products – IoT</title>
      </Helmet>
      <div className="Page_Body">
        <div className="Page_Body_wraper">
          <HeaderSection
            BannerText="Our Leadership "
            Src="/Images/leadershopbanner.webp"
            text="About Us <span>/</span>"
            text1="Our Leadership "
            RouteLink="/#aboutus"
            RouteLink1="/leadership"
            Color2="black"
            Color1="#6C6C6C"
          />

          <div className="leadershipdetails">
            <Text text="Muhammad Uzair Akhtar" FontSize="4rem" FontWeight="700" />
            <Text
              text="Head of Products – IoT"
              FontSize="1.8rem"
              FontWeight="700"
            />
          </div>
          <div className="leadershipdetails2">
            <div className="leadershipImageMob">
              <ImageComp
                Src="/Images/muhammad-uzair-akhtar.webp"
                Radius="120px"
              />
            </div>
            <div className="leaderhsipconent">
              <Text
                text="Muhammad Uzair Akhtar  is a technology professional with expertise on the Internet of Things (IoT), Geoinformatics, and Data Analytics. He holds a degree in Geoinformatics Engineering from Pakistan's National University of Science and Technology (NUST). Uzair has a proven history of developing and implementing innovative technological solutions."
                Color="black"
              />
              <Text
                text="As Head of Products - IoT at DynaSys Networks, Uzair will be responsible for the product strategy and vision, lifecycle management, technology and platform awareness as well as innovation and ecosystem development"
                Margin="35px 0px"
                Color="black"
              />

              <Text
                text="Uzair has been with DynaSys since July 2024 and has already led the implementation of the first-ever LoRaWAN citywide network in Pakistan amongst numerous other trailblazing IoT projects. His diverse experience also includes engineering roles on the NEOM project in Saudi Arabia, where he managed a multidisciplinary design team and coordinated complex IT-related construction initiatives."
                Margin="35px 0px"
                Color="black"
              />
              
            </div>
            <div className="leadershipImage">
              <ImageComp
                Src="/Images/muhammad-uzair-akhtar.webp"
                Radius="120px"
              />
            </div>
          </div>
        </div>
      </div>

      <div className="borderSec">
        <div className="border"></div>
      </div>
        
    </div>
  );
}
